// @ts-nocheck
import React from "react";
import { AuthCheck } from "./AuthCheck";

export default function ProtectedRoutes(props) {
  // const location = useLocation();

  // CheckRole(location.pathname.replace(/\//g, ""));

  AuthCheck()

  const { Component } = props;
  return (
    <>
      <Component />
    </>
  );
}
